import { createReducer } from '../utils'

export const SET_PROGRESS_AMOUNT = 'getcraft/upload/SET_PROGRESS_AMOUNT'
export const SET_UPLOADING_STATUS = 'getcraft/upload/SET_UPLOADING_STATUS'
export const SET_ERROR_UPLOAD = 'getcraft/upload/SET_ERROR_UPLOAD'

const initialStates = {
  isDirectUploading: false,
  isDirectUploadError: false,
  errorDirectUpload: '',
  progressAmount: 0,
}

export default createReducer(initialStates, {
  [SET_ERROR_UPLOAD]: (state, payload) => ({
    ...state,
    isDirectUploadError: payload.isDirectUploadError,
    errorDirectUpload: payload.errorDirectUpload,
  }),
  [SET_UPLOADING_STATUS]: (state, payload) => ({
    ...state,
    isDirectUploading: payload,
  }),
  [SET_PROGRESS_AMOUNT]: (state, payload) => ({
    ...state,
    progressAmount: payload,
  }),
})

export function setErrorUpload(data) {
  return {
    type: [SET_ERROR_UPLOAD],
    payload: data,
  }
}

export function setUploadingStatus(data) {
  return {
    type: [SET_UPLOADING_STATUS],
    payload: data,
  }
}

export function setProgressAmount(data) {
  return {
    type: [SET_PROGRESS_AMOUNT],
    payload: data,
  }
}
